import { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Page = styled.main`
  min-height: calc(100vh - 130px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: ${(p) => p.theme.colors.gray000};
`;

const Card = styled.div`
  width: min(100%, 560px);
  padding: 38px 42px;
  background: ${(p) => p.theme.colors.light};
  border-radius: ${(p) => p.theme.radii.lg};
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 18px;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.md};
`;

const Text = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray400};
  line-height: 1.5;
`;

const PasswordlessLoginRedirect = () => {
  //   @ts-ignore
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useParams<{ user: string }>();

  const backendLoginUrl = useMemo(() => {
    if (!user) return '';

    const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
    return new URL(`${location.pathname}${location.search}`, baseUrl).toString();
  }, [location.pathname, location.search, user]);

  useEffect(() => {
    if (!backendLoginUrl || backendLoginUrl === window.location.href) return;

    window.location.replace(backendLoginUrl);
  }, [backendLoginUrl]);

  return (
    <Page>
      <Card>
        <Title>{t('pbl.pagesHardcoded.passwordlessLoginRedirect.openingSecureLoginLink')}</Title>
        <Text>{t('pbl.pagesHardcoded.passwordlessLoginRedirect.pleaseWaitWhileWePassYourSecureLogin')}</Text>
      </Card>
    </Page>
  );
};

export default PasswordlessLoginRedirect;
